import { Form, Radio, RadioProps, Space, Tooltip } from 'antd'
import React from 'react'
import styles from './RadioField.module.scss'

type RadioFieldProps = RadioProps & {
  validateStatus?: 'error' | 'warning' | 'validating' | 'success' | null
  help?: React.ReactNode
  label?: React.ReactNode
  radioOptions: {
    value: string
    title: string
    disabled?: boolean
    tooltip?: React.ReactNode
    onClick?: (e: any) => void
  }[]
  labelCol?: { span: number }
  infoMessage?: React.ReactNode
}

// Ayrı RadioItem component'i
const RadioItem = React.memo(function RadioItem({
  value,
  title,
  tooltip,
  onClick,
  disabled = false,
  ...radioProps
}: {
  value: string
  title: string
  tooltip?: React.ReactNode
  onClick?: (e: any) => void
  disabled?: boolean
  [key: string]: any
}) {
  const radioElement = (
    <Radio onClick={onClick} value={value} disabled={disabled} {...radioProps}>
      {title}
    </Radio>
  )

  if (tooltip) {
    return (
      <Space align="baseline" size={0}>
        {radioElement}
        {tooltip}
      </Space>
    )
  }

  return radioElement
})

// Ana RadioField component'i
const RadioField = React.memo(function RadioField({
  labelCol,
  label,
  disabled = false,
  radioOptions,
  style,
  name,
  value,
  onChange,
  validateStatus,
  help,
  infoMessage,
  ...rest
}: RadioFieldProps) {
  return (
    <Form.Item
      {...(!disabled && validateStatus ? { validateStatus } : {})}
      {...(!disabled && help ? { help } : {})}
      {...(style ? { style } : {})}
      {...(labelCol ? { labelCol } : {})}
      className={styles.radioField}
      label={label}
    >
      <Radio.Group disabled={disabled} {...{ name, value, onChange }}>
        {radioOptions.map((option) => (
          <RadioItem key={option.value} {...option} {...rest} />
        ))}
      </Radio.Group>
      {infoMessage}
    </Form.Item>
  )
})

export default RadioField
